"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/web.timers.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _useOverlayRoot3 = require("../_utils/hooks/useOverlayRoot");
var _index = require("../Transition/index");
var _useVisibleTransition2 = require("../_utils/hooks/useVisibleTransition");
var _callBoth = require("../_utils/callBoth");
var _uuid = require("../_utils/uuid");
var _useOutsideClick2 = require("../_utils/hooks/useOutsideClick");
var _interface = require("./interface");
var _Mask = _interopRequireDefault(require("../Mask"));
var _device = require("../_utils/device");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var modalStack = [];
var Modal = function Modal(props) {
  var children = props.children,
    visible = props.visible,
    className = props.className,
    caption = props.caption,
    size = props.size,
    mSize = props.mSize,
    onClose = props.onClose,
    onExited = props.onExited,
    disabledCloseIcon = props.disabledCloseIcon,
    destroyOnClose = props.destroyOnClose,
    style = props.style,
    maskClosable = props.maskClosable;
  var ref = (0, _react.useRef)(null);
  var idRef = (0, _react.useRef)((0, _uuid.uuid)());
  var _useOutsideClick = (0, _useOutsideClick2.useOutsideClick)(ref),
    listen = _useOutsideClick.listen,
    ignoreProps = _useOutsideClick.ignoreProps;
  listen(function () {
    if (maskClosable && visible && modalStack[modalStack.length - 1] === idRef.current && onClose) {
      onClose();
    }
  });
  var _useVisibleTransition = (0, _useVisibleTransition2.useVisibleTransition)(visible),
    contentIn = _useVisibleTransition.contentIn,
    shouldContentEnter = _useVisibleTransition.shouldContentEnter,
    shouldContentRender = _useVisibleTransition.shouldContentRender,
    onContentExit = _useVisibleTransition.onContentExit;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('modal');
  (0, _react.useEffect)(function () {
    var id = idRef.current;
    // 等待动画及全部 esc 事件触发完毕
    setTimeout(function () {
      if (visible) {
        modalStack.push(id);
      } else {
        modalStack = modalStack.filter(function (i) {
          return i !== id;
        });
      }
    }, 100);
  }, [visible]);
  var _useOverlayRoot = (0, _useOverlayRoot3.useOverlayRoot)(),
    _useOverlayRoot2 = (0, _slicedToArray2.default)(_useOverlayRoot, 1),
    overlayRoot = _useOverlayRoot2[0];
  if (!shouldContentRender && destroyOnClose) {
    return null;
  }
  var showHd = !!caption || !disabledCloseIcon;
  var sizeCls = '';
  if (size !== 'default' && _interface.SizeArray.indexOf(size) > -1) {
    sizeCls = "size-".concat(size);
  }
  var mSizeCls = mSize !== 'default' ? "m-size-".concat(mSize) : '';
  var classes = (0, _classnames2.default)(prefixCls, className, sizeCls, mSizeCls, (0, _defineProperty2.default)({}, "".concat(prefixCls, "--no-title"), !caption));
  var slideProps = {
    from: [0, -30],
    to: [0, -30]
  };
  if (mSize === 'full' && (0, _device.isMobile)(navigator.userAgent)) {
    slideProps.from = [0, '100%'];
    slideProps.to = [0, '100%'];
  }
  return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__parents"),
    style: {
      display: !destroyOnClose && !contentIn ? 'none' : ''
    }
  }, /*#__PURE__*/_react.default.createElement(_index.FadeTransition, {
    in: shouldContentEnter,
    opacity: 0.5
  }, /*#__PURE__*/_react.default.createElement(_Mask.default, null)), /*#__PURE__*/_react.default.createElement(_index.SlideTransition, (0, _extends2.default)({
    unmountOnExit: destroyOnClose,
    in: shouldContentEnter,
    onExited: (0, _callBoth.callBoth)(onExited, onContentExit)
  }, slideProps), /*#__PURE__*/_react.default.createElement("div", {
    className: classes,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: ref,
    className: "".concat(prefixCls, "__inner"),
    style: size > 0 || /%$/.test(String(size)) ? {
      width: size
    } : {}
  }, ignoreProps), showHd && /*#__PURE__*/_react.default.createElement("header", {
    className: "".concat(prefixCls, "__hd")
  }, caption && /*#__PURE__*/_react.default.createElement("h3", {
    className: "".concat(prefixCls, "__title")
  }, caption), !disabledCloseIcon && /*#__PURE__*/_react.default.createElement("a", {
    className: "".concat(prefixCls, "__close"),
    onClick: onClose
  }, "\u5173\u95ED")), children)))), overlayRoot);
};
Modal.defaultProps = {
  size: 'default',
  mSize: 'default',
  disabledCloseIcon: false,
  destroyOnClose: true
};
var _default = exports.default = Modal;